import axios from 'axios';
import config from 'api/urls-config.json';
import { type_trials } from 'api/constants';

export const getTrialResults = params => {
    return axios.get(`${config.API + config.pages.trail_results}`, { params });
};

export const getTrialResultsFlyers = params => {
    const { slug, language, country } = params;

    return axios.get(`${config.API + config.crops + '/' + slug + '/flyers'}`, {
        params: {
            language,
            country,
        },
    });
};

export const getDetailTrialResults = params => {
    const { slug, language, country, type = type_trials } = params;

    return axios.get(`${config.API + config.crops + '/' + slug}`, {
        params: {
            language,
            country,
            type,
        },
    });
};

export const getAllTrialResults = params => {
    const { language, country, type = type_trials, all = true } = params;

    return axios.get(`${config.API + config.crops}`, {
        params: {
            language,
            country,
            type,
            all,
        },
    });
};
